<div class="container-narrow mb-5">
  <div class="row my-4">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h1 class="m-0 h4 fw-bolder dvi-themed-text-color">{{ 'SHARED.COOKIE-POLICY-PAGE.HEADER' | translate }}</h1>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <p [innerHTML]="'SHARED.COOKIE-POLICY-PAGE.CONTENT' | translate"></p>

      <p>
        <span [translate]="'SHARED.COOKIE-POLICY-PAGE.CHANGE-COOKIE-CONSENT'"></span><br>
        <a class="btn btn-outline-primary mt-3"
           href="#"
           (click)="revokeCookieConsentPopup(); false"
           [translate]="'SHARED.COOKIE-POLICY-PAGE.OPEN-COOKIE-CONSENT-POPUP'"></a>
      </p>
    </div>
  </div>
</div>
